import React, { useEffect, useState ,useRef } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import "./Header.css";
import ThemeToggle from "./ThemeToggle";
import api, { API_ENDPOINTS } from "../config";


const Header = () => {
  const [services, setServices] = useState([]);
  const [scrolled, setScrolled] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const dropdownRef = useRef(null);


  const location = useLocation();
  const isHomePage = location.pathname === "/";

  

  // Detect touch devices
  useEffect(() => {
    setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0);
  }, []);

  // Navbar scroll effect
  useEffect(() => {
    if (isHomePage) {
      const handleScroll = () => setScrolled(window.scrollY > 50);
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    } else {
      setScrolled(false);
    }
  }, [isHomePage]);

  // Fetch services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await api.get(`${API_ENDPOINTS.GET_ALL_SERVICES}`);
        setServices(res.data.services || []);
      } catch (err) {
        console.error("Failed to fetch services", err);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowServices(false); // close dropdown when clicking outside
      }
    };
  
    if (showServices && isTouchDevice) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showServices, isTouchDevice]);
  
  return (
    <Navbar
      expand="lg"
      className={`main-header fixed-top ${
        isHomePage ? (scrolled ? "scrolled" : "") : "static"
      }`}
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <img
            src="/assets/iklim logo final.png"
            alt="Iklim Digitals"
            className="logo"
            style={{ height: "70px", marginLeft: "-40%" }}
          />
        </Navbar.Brand>

        {/* Toggle Button for Mobile */}
        <Navbar.Toggle aria-controls="navbarNav" />

        <Navbar.Collapse
          id="navbarNav"
          className="justify-content-end"
          style={{ marginLeft: "41%" }}
        >
          <Nav className="align-items-center">
            <Nav.Link href="/" className="text-uppercase">
              Home
            </Nav.Link>
            <Nav.Link href="/aboutus" className="text-uppercase">
              About&nbsp;Us
            </Nav.Link>

          {/* Services Dropdown */}
<div
ref={dropdownRef} 
  className={`services-dropdown text-uppercase nav-link ${showServices ? 'open' : ''}`}
  onMouseEnter={() => {
    if (!isTouchDevice) setShowServices(true);
  }}
  onMouseLeave={() => {
    if (!isTouchDevice) setShowServices(false);
  }}
  onClick={() => {
    if (isTouchDevice) setShowServices((prev) => !prev);
  }}
>
  Services
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
    <path fill="currentColor" d="M7 10l5 5 5-5H7z"/>
  </svg>

  {showServices && (
    <ul className="services-menu">
      {services && services.length > 0 ? (
        services.map((svc) => (
          <li key={svc._id}>
            <a href={`/services/${svc._id}`} className="services-item">
              {svc.servicename}
            </a>
          </li>
        ))
      ) : (
        <li className="services-item disabled">No menu items</li>
      )}
    </ul>
  )}
</div>


            <Nav.Link href="/contactus" className="text-uppercase">
              Contact
            </Nav.Link>
          </Nav>

          {/* Theme Toggle */}
          <ThemeToggle />
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
